import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel'; 
import DeleteIcon from '@mui/icons-material/Delete';
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}
function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
export default class Adminjournal extends Component {
    constructor(props) {
    super(props);
	var strdob = new Date();
var month = "";
if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}
const currentDate = new Date();
var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();
 this.state = {
	todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
fromdate:new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
 fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',company:'',se_quotenumber:'',
redirect:false,pagename:'',CustomerData:[] ,id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
search:'',order:'desc' ,orderBy:'jo_id',jo_reference:'',
	 JournalData:[],	 Journalexport:[], journalTotals: {},
	}
	}
 myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 } 
componentWillMount() {
	document.title = "Isifol - Journals";
if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
		  this.JournamGetData(this.state.page,this.state.rowsPerPage);  	
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}
		  let strname="";
	 this.props.parentdasCallback(
            "Journals~"
        ); 
}
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=11')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
        this.JournamGetData(this.state.page,this.state.rowsPerPage);  
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
JournamGetData(page,rowsPerPage){
axios.get(localStorage.getItem("ISIurl")+'ajaxjournal.php?action=getall&jo_cmp_id='+localStorage.getItem("ISIcmpid")+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&jo_reference='+this.state.jo_reference+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  	
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  JournalData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],rowsPaging:copy	
			});
			resp.data.forEach(item => {
    this.GetJournalTotal(item.jo_id);
});
this.Journamexport();
     }
	  else{
		   this.setState({JournalData:[],totaldata:0});
	 }
    });
}
Journamexport(){
axios.get(localStorage.getItem("ISIurl")+'ajaxjournal.php?action=getall&jo_cmp_id='+localStorage.getItem("ISIcmpid")+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&jo_reference='+this.state.jo_reference)
.then(resp => {  	
    if(resp.data.length>0){

        this.setState({  
            Journalexport: resp.data,  
        },()=>{

            resp.data.forEach(item => {
                this.GetJournalTotal(item.jo_id);
            });

        });

    }
    else{
        this.setState({Journalexport:[]});
    }
});
}
handleClickSearch=()=>{
 this.JournamGetData(this.state.page,this.state.rowsPerPage); 
}
handleChangePage = (event, newPage) => {  
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.JournamGetData(this.state.page,this.state.rowsPerPage);  });
  }; 
   handleChangeRowsPerPage = event => {  
    let pageval = event.target.value;
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.JournamGetData(this.state.page,this.state.rowsPerPage); }); 
  };
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
  });
};
fromdatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
    this.setState({
        fromdate: dayjs(dateObj),
        fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}
  toatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
 this.setState({
        todate: dayjs(dateObj),
        todate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
  }
JournalDelete(joid){
	let r =window.confirm("Do you really want to delete");
	if(r==true){
		var formData=new FormData();
		formData.append('action','delete')
		formData.append('jo_id',joid)
		formData.append('userid',localStorage.getItem("ISIuserid"))	
		 axios.post(localStorage.getItem("ISIurl")+"ajaxjournal.php", formData, {
        }).then(res => {
    this.JournamGetData(this.state.page,this.state.rowsPerPage); 
            });
	}
}

GetJournalTotal = (jo_id) => {
    axios.get(
        localStorage.getItem("ISIurl") +
        "ajaxjournal.php?action=journaldetails&jr_jo_id=" + jo_id
    ).then(resp => {

        let total = 0;

        if (resp.data.length > 0) {
            resp.data.forEach(item => {
                total += parseFloat(item.jr_credit || 0);
            });
        }

        this.setState(prevState => ({
            journalTotals: {
                ...prevState.journalTotals,
                [jo_id]: total
            }
        }));
    });
}




	render()
	{
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		return(
		   <React.Fragment>
<div className="searchbox">
<ul>
 <li>
        <p>Search</p>
        <p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.jo_reference}
            id="jo_reference"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="jo_reference"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
<li>
 <p>From Date</p>
<p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
    onChange={this.fromdatehandler} format="MM/DD/YYYY"
	className="txtbox"
/>  </DemoContainer>
</LocalizationProvider></p>
</li>
<li>
 <p>To Date</p>
<p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate)}
className="datepicker"
onChange={this.toatehandler} format="MM/DD/YYYY"
className="txtbox"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
  Search 
</Button>
        &nbsp;
        <ReactHTMLTableToExcel
          variant="contained"
          color="primary"
          id="test-table-xls-button"
          className="exportbtn"
          table="journals"
          filename="journals Report"
          sheet="journals Report"
          buttonText="EXPORT"
        />
      </p>
		</li>
</ul>
</div>	
<div className="addandbacbtn"> <NavLink  to="/Addjournals" className="frmSecondarybtn">New Journal</NavLink></div>				
<div className="clear"></div>	
<div className="estimatebox">
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
	    <TableCell style={{ "width": "10%" }}></TableCell>
            <TableCell>Date</TableCell>
			<TableCell>Reference</TableCell>
			<TableCell>Description</TableCell>
			<TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
  <TableBody>
{stableSort(this.state.JournalData, getSorting(this.state.orderBy, this.state.order)).map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
<TableCell style={{" width": "10%" }}>
<span onClick={()=>{this.JournalDelete(item.jo_id)} } ><DeleteIcon/></span>
</TableCell>
<TableCell><a className="link" href={"#/Journalviewmore?joid="+item.jo_id+""}>{item.journaldate} </a></TableCell>
<TableCell><a className="link" href={"#/Journalviewmore?joid="+item.jo_id+""}>{item.jo_reference} </a></TableCell>
<TableCell><a className="link" href={"#/Journalviewmore?joid="+item.jo_id+""}>{item.jo_description} </a></TableCell>
<TableCell><a className="link" href={"#/Journalviewmore?joid="+item.jo_id+""}> {parseFloat(this.state.journalTotals[item.jo_id] || 0).toFixed(2)}</a></TableCell>
</TableRow>
  </React.Fragment>	
	);
})}
			{this.state.totaldata===0 &&(
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
			)}
 </TableBody>
</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20,50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
 </div>
<div style={{"display":"none"}}>
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table" id="journals"> 
 <TableHead>
          <TableRow>
	    
            <TableCell>Date</TableCell>
			<TableCell>Reference</TableCell>
			<TableCell>Description</TableCell>
			<TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
  <TableBody>
{this.state.Journalexport.map((item,index) => {  
           return ( <React.Fragment>
<TableRow key={index}>
    <TableCell>{item.journaldate}</TableCell>
    <TableCell>{item.jo_reference}</TableCell>
    <TableCell>{item.jo_description}</TableCell>
    <TableCell>
        {'\u200B' + parseFloat(this.state.journalTotals[item.jo_id] || 0).toFixed(2)}
    </TableCell>
</TableRow>
  </React.Fragment>	
	);
})}
 </TableBody>
</Table>
  </TableContainer> 
  </Paper> </div>
</React.Fragment>	
		)
	}
}